import ContentComponent from 'formiojs/components/content/Content';

export default class InstructionContent extends ContentComponent {
    static schema(...extend) {
        return ContentComponent.schema({
            type: 'instructionContent',
            label: 'Instruction Content',
            key: 'instructionContent',
        }, ...extend);
    }

    static get builderInfo() {
        return {
            title: 'Instruction Content',
            group: 'layout',
            icon: 'html5',
            preview: false,
            documentation: '/userguide/forms/layout-components#content',
            weight: 5,
            schema: InstructionContent.schema()
        };
    }
}
